<template>
  <div class="loading" v-show="show">
    <div class="lds-css ng-scope icon">
      <div style="width:100%;height:100%" class="lds-rolling">
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['show']
  }
</script>

<style lang="scss" scoped>
  .loading {
    position: fixed;
    background: rgba(255, 255, 255, 0.6);
    top: 69px;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 9999;

    .icon {
      width: 50px;
      height: 50px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  @keyframes lds-rolling {
    0% {
      -webkit-transform: translate(-50%, -50%) rotate(0deg);
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      -webkit-transform: translate(-50%, -50%) rotate(360deg);
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }

  @-webkit-keyframes lds-rolling {
    0% {
      -webkit-transform: translate(-50%, -50%) rotate(0deg);
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      -webkit-transform: translate(-50%, -50%) rotate(360deg);
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }

  .lds-rolling {
    position: relative;
  }

  .lds-rolling div,
  .lds-rolling div:after {
    position: absolute;
    width: 50px;
    height: 50px;
    border: 4px solid #00b2ff;
    border-top-color: transparent;
    border-radius: 50%;
  }

  .lds-rolling div {
    -webkit-animation: lds-rolling 1s linear infinite;
    animation: lds-rolling 1s linear infinite;
    top: 100px;
  }

  .lds-rolling div:after {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }

  .lds-rolling {
    width: 200px !important;
    height: 200px !important;
    -webkit-transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
    transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
  }
</style>
